import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import CompanySearchForm from "../SearchForm/CompanySearchForm";

const ModalChange = ({ setOpen, open, refer, airports }) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        center
        classNames={{
          modal: "changeModal",
        }}
        blockScroll
      >
        <CompanySearchForm
          airports={airports}
          open={open}
          setOpen={setOpen}
          refer={refer}
        />
      </Modal>
    </div>
  );
};

export default ModalChange;
